import React from 'react';

import { useImperativeRenderAtRoot } from '@reckon-web/utils';

// Renders a dialog imperatively
//
// Note that you must first include the ImperativeRenderAtRootProvider in the app
//
// call like:
// const [openDialog, closeDialog] = useDialog();
// await openDialog(<SomeDialog close={closeDialog} />);

export const useDialog = () => {
  const renderIntoRoot = useImperativeRenderAtRoot();
  let onClose = () => {};

  const wrappedOnClose = () => {
    onClose();
  };

  return [
    async (dialog: React.ReactElement) => {
      const dialogWithOpen = React.cloneElement(dialog, {
        isOpen: true,
        wrappedOnClose,
      } as any);
      onClose = await renderIntoRoot(dialogWithOpen);
      return;
    },
    wrappedOnClose,
  ];
};
